// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__lWlQj","button":"Tooltip_button__nnz2Z","flex":"Tooltip_flex__iuJSo","icon":"Tooltip_icon__P70Xl"};